import React, { useState } from "react";
import GridTable from "cvmgmt-cube-grid-table";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { triggerToast } from "../../utils/toast";
import { getEnv } from "../../Constants/env";
import { useIdToken } from "../../hooks/useAuthSession";
import ConfirmModal from "../Modals/ConfirmModal";
import { adminApprovaDeny } from "../../services/RequestAccess/RequestAccess";

interface CreateEditRoleApprovedUsersProps {
  appId?: number;
  roleId?: number;
  roleName?: string;
}

const CreateEditRoleApprovedUsers: React.FC<CreateEditRoleApprovedUsersProps> = ({
  appId,
  roleId,
  roleName,
}) => {
  const navigate = useNavigate();
  const idToken = useIdToken();
  const { env } = useSelector((state: any) => state?.createApplication);
  const [refresh, setRefresh] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>("");
  const [revokeData, setRevokeData] = useState<any | null>(null);
  const [isRevoking, setIsRevoking] = useState<boolean>(false);

  const handleRevoke = async (rowData: any) => {
    if (isRevoking) return;
    setIsRevoking(true);
    try {
      const response = await adminApprovaDeny({
        action: "revoked",
        accessRoleList: [
          {
            accessRoleId: rowData?.access_id,
            subrequestId: rowData?.subrequest_id,
            approvedRoleIds: [],
            deniedRoleIds: [],
            comment: modalMessage,
          },
        ],
      });
      if (response?.status?.toLowerCase() === "success") {
        triggerToast("Access is successfully revoked", "success");
      } else {
        triggerToast(
          "Something went wrong! Please try after sometime.",
          "error",
        );
      }
    } catch (error) {
      triggerToast("An error occurred while processing your request.", "error");
    } finally {
      setRefresh((prev) => prev + 1);
      setIsModalOpen(false);
      setModalMessage("");
      setIsRevoking(false);
    }
  };

  return (
    <>
      {idToken !== null && env && (
        <GridTable
          title="Users"
          refresh={refresh}
          style={{ height: "calc(100vh - 30.5rem)" }}
          customPayload={true}
          isCustomizeColumns={false}
          isPagination={true}
          apiConfig={{
            url: `${getEnv()?.baseURL}/user/appRoleAccess?role_id=${roleId}&env=${env}`,
            data: {
              sortingFilter: {
                filter: [],
                sort: [],
                page: { limit: 25, offset: 0 },
              },
            },
            headers: {
              Authorization: idToken,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            documentUrl: "",
          }}
          cellActions={[
            {
              event: "View Access",
              callback: (_event: any, data: any) => {
                const rowData = data?.row?.original;
                navigate(
                  `/user-access/${rowData?.workday_id}/features-permissions`,
                  {
                    state: {
                      userId: rowData?.user_id,
                      roleId,
                      workdayID: rowData?.workday_id,
                      role: roleName,
                      accessStatus: "Active",
                      userName: rowData?.user_name,
                    },
                  },
                );
              },
              icon: false,
            },
            {
              event: "Revoke",
              callback: (_event: any, data: any) => {
                setRevokeData(data?.row?.original ?? null);
                setIsRevoking(false);
                setIsModalOpen(true);
              },
              icon: false,
            },
          ]}
          showLoader={false}
        />
      )}
      <ConfirmModal
        value={modalMessage}
        limitmessage={"Reason for Revoking"}
        modalMessage={
          "Please provide a short reason for revoking access in the field below."
        }
        isOpen={isModalOpen}
        headLabel={"Revoke Access"}
        handleClose={() => {
          setIsModalOpen(false);
          setModalMessage("");
        }}
        handleConfirm={() => handleRevoke(revokeData)}
        cancelButtonLabel={"Cancel"}
        confirmButtonLabel={"Revoke"}
        confirmButtonStyle="danger"
        confirmButtonDisabled={isRevoking}
        handleTextFeild={(value: string) => {
          setModalMessage(value);
        }}
      />
    </>
  );
};

export default CreateEditRoleApprovedUsers;

